import React, { Component, Fragment } from 'react';
import { Link } from "react-router-dom";

import { withStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from "@material-ui/icons/Menu";

import { Typography, Box, IconButton } from '@material-ui/core';
import { isEmpty } from "lodash";

const styles = theme => ({
    list: {
        width: 250,
    },
  });

class SideBarMenu extends Component {
    state = {
        openDrawer: false,
    }
    
    toggleDrawer = (open) => {
        this.setState({ openDrawer: open });
    }
	handleLogout = () => {
		localStorage.removeItem("token_8000");
		localStorage.removeItem("userInfo_8000");
		localStorage.removeItem("accessList_8000");
        localStorage.removeItem("tokenMG");

	};
   list = () => ( // this.props.menuList
        <div
            className={this.props.classes.list}
            role="presentation"
            onClick={() => this.toggleDrawer(false)}
            onKeyDown={() => this.toggleDrawer(false)}
        >
            <List>
                <ListItem 
                    button 
                    selected={this.props.SelectedMenu === "Accueil"} 
                    onClick={() => this.props.ClickOnMenu("Accueil")}
                >
                    <ListItemText primary={"Accueil"} />
                </ListItem>
                {!isEmpty(this.props.links) && this.props.links.map( page => (
                    // <Link to={link.to}>
                    <ListItem 
                        button 
                        key={page} 
                        selected={this.props.SelectedMenu === page} 
                        onClick={() => this.props.ClickOnMenu(page)}
                    >
                        <ListItemText primary={page} />
                    </ListItem>
                    
                    // </Link>
                ))}
                {/* Entrées hors liste d'accès, passées par l'application qui monte le menu.
                    Elles ne viennent pas de props.links et ne sont donc visibles que là où
                    elles sont déclarées : ce composant est partagé par les deux consoles. */}
                {Array.isArray(this.props.extraMenu) && this.props.extraMenu.map( page => (
                    <ListItem
                        button
                        key={page}
                        selected={this.props.SelectedMenu === page}
                        onClick={() => this.props.ClickOnMenu(page)}
                    >
                        <ListItemText primary={page} />
                    </ListItem>
                ))}
            </List>
            <Divider />
            <List>                
                {/* <ListItem button key="Déconnexion" component="a" href="/logout/disconnect" >
                    <ListItemText primary="Déconnexion" />
                </ListItem> */}
                <ListItem
						component="a"
						href="/logout/disconnect"
						onClick={this.handleLogout}
					>
                        <ListItemText primary="Déconnexion" />
					</ListItem>
            </List>
        </div>
   )
    render () {
        // console.log('================Side Bar Menu ====================');
        // console.log(this.props);
        // console.log('====================================');
        return (
          <Fragment>        
                <IconButton 
                    onClick={() => this.toggleDrawer(true)} 
                    color="inherit" 
                    aria-label="Menu"
                >
                    <MenuIcon />
                </IconButton>
                <SwipeableDrawer
                    anchor={"left"}
                    open={this.state.openDrawer}
                    onClose={() => this.toggleDrawer(false)}
                    onOpen={() => this.toggleDrawer(true)}
                >
                    <Box p={2}>
                        <Typography variant="h5">MyJouleBox</Typography>
                    </Box>
                    {this.list()}
                </SwipeableDrawer>
          </Fragment>
        )
    }
}

export default withStyles(styles)(SideBarMenu)